<template>
    <div class="ForumExpanded">

        <v-container>

            <v-layout row wrap> <!-- Main layout for left & right -->

                <v-flex xs12 md6> <!-- Left side flex container: User Content, Picture, Map, & Description -->

                    <v-layout column> <!-- A V-layout to have flex to the parent flex element -->

                        <v-flex xs12> <!-- Picture -->
                            <v-responsive class="grey darken-3 pa-2" >
                                <v-img :src="pageData.image" width="95% ma-auto">
                                </v-img>
                            </v-responsive>
                        </v-flex>

                        <v-flex xs12> <!-- User Profile -->
                            <v-list>
                                
                                <v-list-tile avatar>
                                    <v-list-tile-avatar>
                                        <img :src="pageData.userAvatar" alt=""> <!-- User Profile Image -->
                                    </v-list-tile-avatar>
                                    
                                    <span class="subheading">{{pageData.userName}}</span> <!-- UserName & Description -->

                                    <v-spacer></v-spacer>

                                    <v-list-tile-action v-if="pageData.verified">
                                        <v-btn icon>
                                            <v-icon>verified_user</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>

                                </v-list-tile>
                                <v-divider class="py-1"> </v-divider>
                            </v-list>

                            <v-card flat> <!--Description & Stuff -->
                                <v-card-title class="pt-1 pb-0">
                                    Description
                                </v-card-title>

                                <v-card-text class="py-0">
                                    <span>{{pageData.misc}}</span>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 class="hide-sm-and-down">
                            <div id="map" class="my-3" style="display: flex; justify-content:center">
                                <GmapMap :center="{lat: parseFloat(pageData.lat), lng: parseFloat(pageData.long)}" :zoom="11" 
                                style="display: table; width: 90%; height: 300px; margin 0 auto; border: 4px solid #7AC8C0; border-radius: 50px 0px 0px 0px; overflow:hidden"
                                >
                                
                                    <gmap-marker
                                    :position="{lat: parseFloat(pageData.lat), lng: parseFloat(pageData.long)}"
                                    @click="center={lat: parseFloat(pageData.lat), lng: parseFloat(pageData.long)}"
                                    ></gmap-marker>

                                </GmapMap>
                            </div>
                            <div v-if="admin">
                                <v-btn depressed color="green lighten-3 white--text" @click="vertifyHit()">
                                    <span>Vertify</span>
                                </v-btn>
                            </div>
                        </v-flex>
                        

                    </v-layout>

                </v-flex>

                <v-flex xs12 md6> <!-- Ride Side Container: Contains comments and comment response -->

                    <v-list three-line>

                        <v-subheader>Comments</v-subheader>

                        

                        <v-card class="px-2" flat>
                            <v-card-actions>
                                <v-textarea v-model="comment" :counter="140" placeholder="Your Comment Here" autoGrow no-resize height="50px">

                                </v-textarea>
                                <v-btn @click="postComment" depressed color="blue lighten-3">
                                    <span>Post</span>
                                </v-btn>
                            </v-card-actions>
                            
                            <!-- <v-card-title>
                                <v-avatar size="36px">
                                    <img :src="require('@/assets/user.jpg')" alt="User Profile">
                                </v-avatar>
                            </v-card-title> -->
                        </v-card>

                        <template v-for="comments in pageData.comments">
                            
                            <v-card :key="comments.message" flat>
                                <v-card-title>
                                    <v-avatar size="36px">
                                        <img :src="comments.userProfilePic" alt="User Profile Picture">
                                    </v-avatar>
                                    <span class="pl-3">{{comments.userName}}</span>
                                </v-card-title>

                                <v-card-text class="ml-3 pt-0 pb-1">
                                    <span>{{comments.message}}</span>
                                </v-card-text>
                                
                            </v-card>

                        </template>

                    </v-list>

                </v-flex>

            </v-layout>

            <v-snackbar v-model="success" bottom right :timeout="2000">
                    Successfully Vertified!
            </v-snackbar>

        </v-container>

    </div>
</template>

<script>
import {bus} from '@/main.js';
import {database,auth} from '@/fb.js';
import {firebase} from '@firebase/app';

export default {
    created() {
        bus.$on('handData', (data) => {
            this.pageData = data;
        });

        console.log(this.pageData);
    },
    props: {
        admin: Boolean
    },
    data() {
        return {
            pageData: {},
            comment: '',
            success: false,
            dummyData: [
                {userProfilePic:require('@/assets/commentUser.jpg'),username:'LegoDude',message:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis ratione, alias voluptatum animi natus quas incidunt dolore nam, dolor quod amet quibusdam minus maxime provident fuga, esse iusto totam quae!'},
                {userProfilePic:require('@/assets/anime.png'),username:'LegoSlimShaddy',message:'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sed iaculis dolor, blandit faucibus orci. Proin gravida nec nunc sed mattis. Donec a tempor libero. Sed vel turpis feugiat, suscipit sem nec, posuere orci. Integer eleifend urna sed quam mollis, quis maximus magna mollis. Integer finibus venenatis lectus sit amet rutrum. Morbi pharetra congue risus at dictum. Sed sit amet sapien lorem. Aliquam non condimentum enim. Nulla dapibus ultricies tempus. Donec laoreet sed sem vitae ullamcorper.'},
                {userProfilePic:require('@/assets/anime.png'),username:'KeyManLego',message:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perferendis ratione, alias voluptatum animi natus quas incidunt dolore nam, dolor quod amet quibusdam minus maxime provident fuga, esse iusto totam quae!'},
            ]
        }
    },
    methods: {
        postComment() {
            database.collection("Pins").where("specialID","==",this.pageData.specialID).get().then(query => {
                query.forEach(doc => {
                    
                    database.collection("Pins").doc(doc.id).update({
                        comments: firebase.firestore.FieldValue.arrayUnion({
                            userProfilePic: auth.currentUser.photoURL,
                            userName: auth.currentUser.displayName,
                            message: this.comment
                        })
                    }).then(() => {
                        this.pageData.comments.push({
                            userProfilePic: auth.currentUser.photoURL,
                            userName: auth.currentUser.displayName,
                            message: this.comment
                        });
                        this.comment = '';
                    });

                })
            });
        },
        vertifyHit() {
            database.collection("Pins").where("specialID","==",this.pageData.specialID).get().then(query => {
                query.forEach(doc => {
                    
                    database.collection("Pins").doc(doc.id).update({
                        verified: true
                    }).then(() => {
                        this.success = true;
                    })

                })
            })
        }
    }
}
</script>